/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeLanguageRequest as DigiworkMaitreDPosDtoAdvertiserChangeLanguageRequest } from '../../models/Digiwork/MaitreD/Pos/DTO/Advertiser/change-language-request';

export interface Changelanguage_2$Params {
      body?: DigiworkMaitreDPosDtoAdvertiserChangeLanguageRequest
}

export function changelanguage_2(http: HttpClient, rootUrl: string, params?: Changelanguage_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changelanguage_2.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changelanguage_2.PATH = '/api/gmn/User/changelanguage';
